$(function () {
    var contbtn = $('.pr_connect-btn'),
        condeta_ttl = $('.pr_connect-ttl'),
        typedetail = $('.pr_connect-detalist'),
        typedetail_li = $('.pr_connect-detalist li'),
        delaybox = typedetail.find('.pr_connect-delaybox'),
        detailh = $('.pr_connect-detalist li').outerHeight();

    //smothscroll TOPへ戻る
    function pr_linktop() {
        var target = condeta_ttl,
            speed = 1200,
            hnavh = $('.header-content').outerHeight(),
            position = target.offset().top,
            positop = position - hnavh - 60;
        if (window.matchMedia('(max-width: 1050px)').matches) {
            positop = position - hnavh - 90;
        }
        $("html, body").animate({ scrollTop: positop }, speed, "swing");
        return false;
    }
    contbtn.children().click(function () {
        pr_linktop();
    });

    delaybox.css({ 'opacity': 1 });
    typedetail.css('height', detailh);

    $(window).on('load resize', function () {
        var eh = typedetail_li.outerHeight();
        typedetail.css('height', eh);
    });

    //arrow add
    $('.pr_connect-deta-on .pr_aging-detabox + .pr_aging-detabox').before('<div class="pr_connect-deta-arrowr pr_connect-delaybox"></div>');
    contbtn.children().click(function () {
        var relate = $('.pr_connect-btn li').index(this),
            relateh = typedetail_li.eq(relate).outerHeight();

        if ($(this).hasClass('pr_connect-btn-on')) {
            return false;
        }

        contbtn.children().removeClass('pr_connect-btn-on');
        $(this).addClass('pr_connect-btn-on');

        condeta_ttl.children().css({ 'opacity': 0 });
        condeta_ttl.children().eq(relate).css({ 'opacity': 1 });


        typedetail_li.stop(true, false).animate({ 'opacity': 0 }).removeClass('pr_connect-deta-on');
        typedetail_li.eq(relate).animate({ 'opacity': 1 }).addClass('pr_connect-deta-on');
        typedetail.stop(true, false).animate({ 'height': relateh }, 500);
        delaybox.stop(true, false).animate({ 'opacity': 0 });

        setTimeout(function () {
            $('.pr_connect-detalist li').eq(relate).find(delaybox).each(function (i) {
                $(this).delay(500 * i).animate({ 'opacity': 1 });
            });
        }, 1500);
    });
});

